import { Resource_AppointmentTaskStatus } from '@/generated/graphql';
import { CheckCircleOutlined } from '@ant-design/icons';
import { AppointmentTaskComponent } from '@components/appointment-details/appointment-tasks/types';
import { AveliosButton } from '@components/common-layout/avelios-button';
import { Divider, Space } from 'antd';
import { useRouter } from 'next/router';
import { FC } from 'react';
import { useIntl } from 'react-intl';
import { extractTranslation } from '../../../../helpers/formatters';

export const InfoAppointmentTask: FC<AppointmentTaskComponent> = ({
  proxyAppointmentTask,
  updateAppointmentTaskStatus,
}) => {
  const { formatMessage } = useIntl();
  const router = useRouter();

  const appointmentTask = proxyAppointmentTask.appointmentTask;
  const information = appointmentTask?.information;

  const done =
    appointmentTask?.status === Resource_AppointmentTaskStatus.AppointmentTaskStatusFinished;

  return (
    <Space style={{ width: '100%' }} direction={'vertical'}>
      {information
        ? extractTranslation(information, router.locale)
        : formatMessage({ id: 'appointment-tasks.info.empty' })}
      <Divider />
      <AveliosButton
        style={done ? { backgroundColor: 'darkgreen', color: 'white' } : undefined}
        disabled={done}
        onClick={() =>
          updateAppointmentTaskStatus(Resource_AppointmentTaskStatus.AppointmentTaskStatusFinished)
        }
        block
        type={'primary'}
        icon={<CheckCircleOutlined />}
      >
        {done
          ? formatMessage({ id: 'appointment-tasks.info.marked-as-read' })
          : formatMessage({ id: 'appointment-tasks.info.mark-as-read' })}
      </AveliosButton>
    </Space>
  );
};
